var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgIdeaSharing = function SvgIdeaSharing(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50pt",
    height: "50pt",
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 29.5625,
    y1: 79.880562,
    x2: 29.5625,
    y2: 133.638626,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(49.803922%,92.941177%,76.862746%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(58.431375%,71.764708%,100%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear1",
    gradientUnits: "userSpaceOnUse",
    x1: 99.375687,
    y1: 32.473061,
    x2: 99.375687,
    y2: 54.378868,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(49.803922%,92.941177%,76.862746%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(58.431375%,71.764708%,100%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear2",
    gradientUnits: "userSpaceOnUse",
    x1: 86,
    y1: 16.06856,
    x2: 86,
    y2: 152.177002,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(12.156863%,86.666667%,58.431375%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(14.509805%,42.745098%,99.607843%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear3",
    gradientUnits: "userSpaceOnUse",
    x1: 99.4375,
    y1: 16.125,
    x2: 99.4375,
    y2: 152.233444,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(12.156863%,86.666667%,58.431375%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(14.509805%,42.745098%,99.607843%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface2310117"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear0)"
    },
    d: "M 6.25 24.21875 L 10.9375 24.21875 L 10.9375 39.0625 L 6.25 39.0625 Z M 6.25 24.21875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear1)"
    },
    d: "M 29.269531 9.675781 L 29.445312 10.558594 C 29.585938 11.25 30.121094 11.792969 30.804688 11.933594 L 31.683594 12.109375 C 32.097656 12.195312 32.097656 12.792969 31.683594 12.878906 L 30.804688 13.058594 C 30.121094 13.195312 29.582031 13.738281 29.445312 14.429688 L 29.269531 15.3125 C 29.183594 15.730469 28.589844 15.730469 28.507812 15.3125 L 28.332031 14.429688 C 28.191406 13.738281 27.65625 13.195312 26.96875 13.054688 L 26.09375 12.878906 C 25.679688 12.792969 25.679688 12.195312 26.09375 12.109375 L 26.96875 11.929688 C 27.65625 11.792969 28.191406 11.25 28.332031 10.558594 L 28.507812 9.675781 C 28.589844 9.257812 29.183594 9.257812 29.269531 9.675781 Z M 29.269531 9.675781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear2)"
    },
    d: "M 44.082031 30.324219 C 43.351562 29.78125 42.375 29.625 41.398438 29.894531 L 29.457031 33.195312 C 29.601562 32.835938 29.6875 32.441406 29.6875 32.023438 C 29.6875 30.304688 28.285156 28.90625 26.5625 28.90625 L 19.238281 28.90625 C 18.714844 28.125 17.390625 25.78125 15.625 25.78125 L 12.5 25.78125 L 12.5 25 C 12.5 23.707031 11.449219 22.65625 10.15625 22.65625 L 7.03125 22.65625 C 5.738281 22.65625 4.6875 23.707031 4.6875 25 L 4.6875 38.28125 C 4.6875 39.574219 5.738281 40.625 7.03125 40.625 L 10.15625 40.625 C 11.449219 40.625 12.5 39.574219 12.5 38.28125 L 12.5 37.695312 L 21.984375 44.101562 C 23.175781 44.90625 24.558594 45.3125 25.949219 45.3125 C 27.230469 45.3125 28.515625 44.96875 29.652344 44.273438 L 43.851562 35.601562 C 44.753906 35.050781 45.3125 34.050781 45.3125 32.996094 L 45.3125 32.75 C 45.3125 31.789062 44.863281 30.90625 44.082031 30.324219 Z M 10.9375 38.28125 C 10.9375 38.710938 10.585938 39.0625 10.15625 39.0625 L 9.375 39.0625 L 9.375 35.9375 L 7.8125 35.9375 L 7.8125 39.0625 L 7.03125 39.0625 C 6.601562 39.0625 6.25 38.710938 6.25 38.28125 L 6.25 25 C 6.25 24.570312 6.601562 24.21875 7.03125 24.21875 L 10.15625 24.21875 C 10.585938 24.21875 10.9375 24.570312 10.9375 25 Z M 43.75 32.996094 C 43.75 33.511719 43.476562 34 43.035156 34.265625 L 28.839844 42.9375 C 26.992188 44.066406 24.644531 44.015625 22.859375 42.808594 L 12.5 35.808594 L 12.5 27.34375 L 15.625 27.34375 C 16.453125 27.34375 17.554688 28.933594 18.039062 30.007812 L 18.246094 30.46875 L 26.5625 30.46875 C 27.425781 30.46875 28.125 31.167969 28.125 32.023438 C 28.125 32.890625 27.425781 33.59375 26.5625 33.59375 L 18.75 33.59375 L 18.75 35.15625 L 28.125 35.15625 L 41.816406 31.402344 C 42.316406 31.261719 42.816406 31.328125 43.152344 31.578125 C 43.53125 31.863281 43.75 32.289062 43.75 32.75 Z M 43.75 32.996094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear3)"
    },
    d: "M 25.585938 19.550781 C 24.816406 19.648438 24.21875 20.300781 24.21875 21.09375 L 24.21875 22.65625 C 24.21875 23.519531 24.917969 24.21875 25.78125 24.21875 L 25.925781 24.21875 C 26.25 25.125 27.109375 25.78125 28.125 25.78125 L 29.6875 25.78125 C 30.703125 25.78125 31.5625 25.125 31.886719 24.21875 L 32.03125 24.21875 C 32.894531 24.21875 33.59375 23.519531 33.59375 22.65625 L 33.59375 21.09375 C 33.59375 20.300781 32.996094 19.648438 32.226562 19.550781 C 34.9375 18.273438 36.71875 15.539062 36.71875 12.5 C 36.71875 8.191406 33.214844 4.6875 28.90625 4.6875 C 24.597656 4.6875 21.09375 8.191406 21.09375 12.5 C 21.09375 15.539062 22.875 18.273438 25.585938 19.550781 Z M 32.03125 22.65625 L 25.78125 22.65625 L 25.78125 21.09375 L 32.03125 21.09375 Z M 28.90625 6.25 C 32.351562 6.25 35.15625 9.054688 35.15625 12.5 C 35.15625 15.136719 33.480469 17.503906 30.988281 18.386719 L 30.46875 18.570312 L 30.46875 19.53125 L 27.34375 19.53125 L 27.34375 18.570312 L 26.824219 18.386719 C 24.332031 17.503906 22.65625 15.136719 22.65625 12.5 C 22.65625 9.054688 25.460938 6.25 28.90625 6.25 Z M 28.90625 6.25 "
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIdeaSharing, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/idea-sharing.4c167dac.svg";
export { ForwardRef as ReactComponent };